import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ChatInterface from '../components/chat/ChatInterface';
import { modelsService } from '../services/modelsService';
import { Button } from '../components/ui';
import styles from '../styles/pages/ChatPage.module.css';

interface ChatPageState {
  selectedModel?: string;
  source?: string;
}

const ChatPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState<string | null>(null);
  const [modelName, setModelName] = useState<string>('');
  const [source, setSource] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadModelData = async () => {
      const state = location.state as ChatPageState;
      if (state?.selectedModel) {
        setSelectedModel(state.selectedModel);
        setSource(state.source || null);
        
        try {
          // Get model details from backend models service
          const model = await modelsService.getModelById(state.selectedModel);
          if (model) {
            setModelName(model.name);
          } else {
            setModelName(state.selectedModel);
          }
        } catch (error) {
          console.error('Failed to load model details:', error);
          setModelName(state.selectedModel);
        }
      } else {
        setError('No model selected. Please select a model from the gallery.');
      }
      setIsLoading(false);
    };

    loadModelData();
  }, [location.state]);

  const handleBackToModels = () => {
    navigate('/models');
  };

  if (isLoading) {
    return (
      <div className={styles.chatPage}>
        <div className={styles.loading}>
          <div className={styles.loadingSpinner} />
          <p>Loading chat interface...</p>
        </div>
      </div>
    );
  }

  if (error || !selectedModel) {
    return (
      <div className={styles.chatPage}>
        <div className={styles.error}>
          <div className={styles.errorIcon}>⚠️</div>
          <h2>Unable to Load Chat</h2>
          <p>{error || 'No model selected'}</p>
          <Button
            variant="primary"
            onClick={handleBackToModels}
          >
            Back to Models Gallery
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.chatPage}>
      <ChatInterface
        modelId={selectedModel}
        modelName={modelName || selectedModel}
        onBack={source === 'models-gallery' ? handleBackToModels : undefined}
      />
    </div>
  );
};

export default ChatPage;